"use client";
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Overlay = void 0;
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const foundations_1 = require("../../foundations");
const useOverlay_1 = require("../../hooks/useOverlay");
const Overlay = ({ visible, onDismiss, sx, children }) => {
    const [, setForceUpdate] = react_1.default.useState(0);
    const [hasTransitionedOut, setHasTransitionedOut] = react_1.default.useState(true);
    const { mountOverlay, unmountOverlay, getOverlayZIndex } = (0, useOverlay_1.useOverlay)();
    const overlayIdRef = react_1.default.useRef(0);
    const overlayZIndex = getOverlayZIndex(overlayIdRef.current);
    const portalRef = react_1.default.useRef(null);
    const background = react_1.default.useMemo(() => {
        return overlayZIndex === 1 ? "backgroundOverlay01" : "unset";
    }, [overlayZIndex]);
    const handleClick = react_1.default.useCallback((e) => {
        // If the overlay is being clicked
        if (e.target === e.currentTarget) {
            onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
        }
    }, [onDismiss]);
    const handleTransitionEnd = react_1.default.useCallback((e) => {
        if (e.currentTarget === e.target && !visible) {
            setHasTransitionedOut(true);
            unmountOverlay(overlayIdRef.current);
        }
    }, [unmountOverlay, visible]);
    react_1.default.useEffect(() => {
        // Force a render on mount so the element exists and
        // transitions start working
        setForceUpdate(1);
    }, []);
    react_1.default.useEffect(() => {
        portalRef.current = document.createElement("div");
        if (portalRef.current) {
            document.body.appendChild(portalRef.current);
        }
        return () => {
            if (portalRef.current) {
                document.body.removeChild(portalRef.current);
            }
        };
    }, []);
    react_1.default.useEffect(() => {
        const handleDocumentKeyDown = (e) => {
            if (e.key.toLowerCase() === "escape" || e.key.toLowerCase() === "esc") {
                onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
            }
        };
        window.addEventListener("keydown", handleDocumentKeyDown);
        return () => {
            window.removeEventListener("keydown", handleDocumentKeyDown);
        };
    }, [onDismiss]);
    react_1.default.useEffect(() => () => {
        // Unmount the overlay from the stack if the component
        // is unmounted from the DOM
        unmountOverlay(overlayIdRef.current);
    }, [unmountOverlay]);
    react_1.default.useEffect(() => {
        if (visible && hasTransitionedOut) {
            const newOverlayId = mountOverlay();
            overlayIdRef.current = newOverlayId;
            setHasTransitionedOut(false);
        }
    }, [hasTransitionedOut, mountOverlay, visible]);
    if (!portalRef.current) {
        return null;
    }
    return react_dom_1.default.createPortal(react_1.default.createElement(foundations_1.Box, { "aria-hidden": !visible, role: "dialog", sx: Object.assign(Object.assign({}, sx), { background, height: !hasTransitionedOut ? "100%" : 0, left: 0, opacity: !visible ? 0 : 1, overflow: "hidden", position: "fixed", top: 0, transition: "easeOutMedium", width: "100%", zIndex: (theme) => { var _a; return ((_a = theme === null || theme === void 0 ? void 0 : theme.zIndices) === null || _a === void 0 ? void 0 : _a.modal) + overlayZIndex; } }), onClick: handleClick, onTransitionEnd: handleTransitionEnd }, visible || !hasTransitionedOut ? children : null), portalRef.current);
};
exports.Overlay = Overlay;
//# sourceMappingURL=Overlay.js.map